import { create } from 'zustand'
import { useShallow } from 'zustand/react/shallow'

interface NetworkStatusState {
  isOnline: boolean
  /** True if the user transitioned from offline → online recently (cleared after reconnect handler runs) */
  wasOffline: boolean
  setOnline: () => void
  setOffline: () => void
  clearWasOffline: () => void
}

const getInitialOnline = () => {
  if (typeof navigator === 'undefined') return true
  return navigator.onLine !== false
}

export const useNetworkStatusStore = create<NetworkStatusState>((set) => ({
  isOnline: getInitialOnline(),
  wasOffline: false,
  setOnline: () =>
    set((s) => ({
      isOnline: true,
      // Mark transition only if we were offline before
      wasOffline: !s.isOnline ? true : s.wasOffline,
    })),
  setOffline: () => set({ isOnline: false, wasOffline: true }),
  clearWasOffline: () => set({ wasOffline: false }),
}))

/**
 * Selector hook. Destructure what you need — all values/actions are stable.
 */
export function useNetworkStatus() {
  return useNetworkStatusStore(
    useShallow((s) => ({
      isOnline: s.isOnline,
      wasOffline: s.wasOffline,
      setOnline: s.setOnline,
      setOffline: s.setOffline,
      clearWasOffline: s.clearWasOffline,
    })),
  )
}
